import { useTranslation } from 'react-i18next'

/**
 * Moja Biblioteka styled coming-soon placeholder.
 *
 * Used for MVP features inside the library area that are not yet active.
 */
export default function LibraryComingSoonPage() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh]">
      <section
        className="bg-[var(--library-card-bg)] backdrop-blur-md rounded-3xl p-8 md:p-12 shadow-xl border border-[var(--library-border)] text-center w-full max-w-2xl"
      >
        <h1 className="font-climate text-3xl md:text-5xl text-brand-blue mb-4">
          {t('library.comingSoon.title')}
        </h1>
        <p className="text-brand-blue/90 text-base md:text-lg">
          {t('library.comingSoon.message')}
        </p>
      </section>
    </div>
  )
}
